// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__TYf_J","consentsList":"PatientConsents_consentsList__1r5zv","consentsListEmpty":"PatientConsents_consentsListEmpty__1pkl3"};